module.exports = __webpack_public_path__ + "static/media/bg.6b2582a5.svg";